import React, { useEffect, useState } from "react";
import useAxios from "axios/httpService";
import { useHistory, useParams } from "react-router-dom";
/* eslint-disable react/prop-types */
import { GetInquiryByIdUrl } from "axios/commonAPIsUrls";
import Loading from "components/Loading/Loading";
import CustomMetricsFields from "views/Common/CustomMetrics/CustomMetricsFields";
import { GetCustomQuestionbyIdUrl } from "axios/commonAPIsUrls";

const ViewCustomMetrics = () => {
  const history = useHistory();
  const { inquiryParamId, CustomParamId } = useParams();
  const [fields, setFields] = useState({
    Title: "",
    Type: "",
    Description: "",
    Area: "",
    Inquiry: inquiryParamId,
    MaxLength: 200,
    ValidationRegex: "",
    AddedBy: "constant@gmail.com",
    RadioButtonOptions: [],
    CheckBoxOptions: [],
  });
  const [inquiryMenu, setInquiryMenu] = useState({});

  const token = localStorage.getItem("token");

  const [
    { data, loading: loadingInquiryById, error },
    ExecuteGetInquiryByIdUrl,
  ] = useAxios(GetInquiryByIdUrl(inquiryParamId, token));

  const [
    { data: dataQuestion, loading: loadingQuestion, error: errorQuestion },
    ExecuteGetCustomQuestionbyIdUrl,
  ] = useAxios(GetCustomQuestionbyIdUrl(CustomParamId, token));

  useEffect(() => {
    ExecuteGetInquiryByIdUrl();
    ExecuteGetCustomQuestionbyIdUrl();
  }, []);

  useEffect(() => {
    if (dataQuestion) {
      setFields({
        ...fields,
        Title: dataQuestion.Title,
        Type: dataQuestion.Type,
        Description: dataQuestion.Description,
        Area: dataQuestion.Area,
        MaxLength: dataQuestion.MaxLength,
        ValidationRegex: dataQuestion.ValidationRegex,
        AddedBy: dataQuestion.CreatedBy,
        RadioButtonOptions: dataQuestion.RadioButtonOptions,
        CheckBoxOptions: dataQuestion.CheckBoxOptions,
      });
    }
  }, [dataQuestion]);

  useEffect(() => {
    if (data) {
      setInquiryMenu({
        id: data.Id,
        label: data.Description,
      });
    }
  }, [data]);

  const prerequisiteValue = {
    title: "View Custom Added Question",
    goBackLink: "/superAdmin/custom-metrics",
    disabledArea: true,
    disabled: true,
  };
  if (loadingInquiryById || loadingQuestion) {
    return <Loading loading />;
  }

  return (
    <CustomMetricsFields
      fields={fields}
      setFields={setFields}
      prerequisiteValue={prerequisiteValue}
      inquiryMenu={inquiryMenu}
    />
  );
};

export default ViewCustomMetrics;
